<template>
  <div class="modal fade" id="modal-edit-faq">
    <div class="modal-dialog modal-dialog-l">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
          </button>
          <h4 class="modal-title">{{$t('trainings.faqs.added-form.title')}}</h4>
        </div>
        <div v-if="faq != null" class="modal-body">
          <div class="box">
            <div v-if="!isBackoffice()" class="form-group">
              <label>{{$t('trainings.faqs.added-form.question')}}</label>
              <input type="text" v-model="faq.question[$root.$i18n.locale]" class="form-control"
                     placeholder="">
            </div>
            <div v-if="isBackoffice()" class="form-group">
              <label>{{$t('trainings.faqs.added-form.question')}} [en]</label>
              <input type="text" v-model="faq.question['en']" class="form-control"
                     placeholder="">
            </div>
            <div v-if="isBackoffice()" class="form-group">
              <label>{{$t('trainings.faqs.added-form.question')}} [ru]</label>
              <input type="text" v-model="faq.question['ru']" class="form-control"
                     placeholder="">
            </div>

            <div v-if="!isBackoffice()" class="form-group">
              <label>{{$t('trainings.faqs.added-form.answer')}}</label>
              <textarea style="height: 300px;" v-model="faq.answer[$root.$i18n.locale]" class="form-control"></textarea>
            </div>
            <div v-if="isBackoffice()" class="form-group">
              <label>{{$t('trainings.faqs.added-form.answer')}} [en]</label>
              <textarea style="height: 300px;" v-model="faq.answer['en']" class="form-control"></textarea>
            </div>
            <div v-if="isBackoffice()" class="form-group">
              <label>{{$t('trainings.faqs.added-form.answer')}} [ru]</label>
              <textarea style="height: 300px;" v-model="faq.answer['ru']" class="form-control"></textarea>
            </div>

            <div class="form-group">
              <label>
                <input type="checkbox" :value="faq.isPublish"
                       name="isPublish" v-model="faq.isPublish">
                {{ $t('trainings.faqs.is-publish') }}
              </label>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default pull-left" data-dismiss="modal">{{$t('button.close')}}</button>
          <button v-on:click="updateFaq" type="button" class="btn btn-primary">{{$t('button.save-changes')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'SportProgramAddFaq',
  props: {
    sportProgram: Object,
    faq: Object
  },
  created () {
  },
  data () {
    return {
    };
  },
  methods: {
    isBackoffice: function () {
      return window.application !== 'cabinet';
    },
    isCabinet: function () {
      return window.application === 'cabinet';
    },
    updateFaq: function () {
      let self = this;

      // const AuthStr = 'Bearer ' + JSON.parse(localStorage.getItem('user')).token;

      let data = {
        question: this.faq.question,
        answer: this.faq.answer,
        isPublish: this.faq.isPublish
      };

      axios.put(window.host + '/sport-programs/' + self.sportProgram.id + '/faqs/' + this.faq.id, data)
        .then(function (response) {
          console.log(response.data);
          self.$root.$emit('alert', 'success', 'alert.success');
          self.$root.$emit('showFaqs', self.sportProgram.id, self.sportProgram.camp.id);
        })
        .catch(function () {
          self.$root.$emit('alert', 'error', 'alert.error');
        });
    }
  }
};
</script>

<style>
  .modal-dialog-l {
    width: 80%;
  }
</style>
